import { ResponsibleForProjectType } from '@symfa-inc/providence-verizon-types';
import { arraySort } from '@core/utils/methods/array-sort';
import { stringEnumToSelectableObject } from '@core/utils/methods/enum-to-selectable-object';

export const RESPONSIBLE_FOR_PROJECT_TYPE_OPTIONS = arraySort(
  stringEnumToSelectableObject(ResponsibleForProjectType),
  'ASC',
  'viewValue',
);
